import { Component, Inject, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { ToolboxService } from '../toolbox.service';

export enum ToolboxType {
  static,
  overlay,
}

@Component({
  selector: 'toolbox-trigger',
  templateUrl: './toolbox-trigger.component.html',
  styleUrls: [ './toolbox-trigger.component.scss' ],
})
export class ToolboxTriggerComponent
{
  private static readonly ICONS: Array<string> =
      ['layouts', 'products', 'preview'];

  @Input() public triggerName: string;
  @Input() public toolbox: string;

  constructor(
      private mir: MatIconRegistry,
      private sanitizer: DomSanitizer,
      @Inject(ToolboxService) private toolboxService: ToolboxService)
  {
    this.loadIcons();
  }

  private loadIcons(): void
  {
    for (const icon of ToolboxTriggerComponent.ICONS) {
      this.mir.addSvgIcon(
          icon,
          this.sanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/${icon}.svg`));
    }
  }

  public openToolbox(): void
  {
    if (this.toolbox) {
      this.toolboxService.open(this.toolbox);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/toolboxes/toolbox-trigger/toolbox-trigger.component.ts